(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  const targets = document.querySelectorAll('.frivio-section .frivio-wrap, .frv-room');
  targets.forEach(el => el.setAttribute('data-frv-reveal', ''));
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: .08, rootMargin: '0px 0px 40px 0px' });
  targets.forEach(el => observer.observe(el));
})();
